//
// Copyright 2020 DXOS.org
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file dxos/echo/timeframe.proto (package dxos.echo.timeframe, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file dxos/echo/timeframe.proto.
 */
export const file_dxos_echo_timeframe: GenFile = /*@__PURE__*/
  fileDesc("ChlkeG9zL2VjaG8vdGltZWZyYW1lLnByb3RvEhNkeG9zLmVjaG8udGltZWZyYW1lInUKD1RpbWVmcmFtZVZlY3RvchI6CgZmcmFtZXMYASADKAsyKi5keG9zLmVjaG8udGltZWZyYW1lLlRpbWVmcmFtZVZlY3Rvci5GcmFtZRomCgVGcmFtZRIQCghmZWVkX2tleRgBIAEoDBILCgNzZXEYAyABKAVCNFoyZ2l0aHViLmNvbS9keG9zL2R4b3MvcHJvdG8vZGVmL2R4b3MvZWNoby90aW1lZnJhbWViBnByb3RvMw");

/**
 * *
 * Vector timestamp used to order messages.
 *
 * @generated from message dxos.echo.timeframe.TimeframeVector
 */
export type TimeframeVector = Message<"dxos.echo.timeframe.TimeframeVector"> & {
  /**
   * @generated from field: repeated dxos.echo.timeframe.TimeframeVector.Frame frames = 1;
   */
  frames: TimeframeVector_Frame[];
};

/**
 * Describes the message dxos.echo.timeframe.TimeframeVector.
 * Use `create(TimeframeVectorSchema)` to create a new message.
 */
export const TimeframeVectorSchema: GenMessage<TimeframeVector> = /*@__PURE__*/
  messageDesc(file_dxos_echo_timeframe, 0);

/**
 * @generated from message dxos.echo.timeframe.TimeframeVector.Frame
 */
export type TimeframeVector_Frame = Message<"dxos.echo.timeframe.TimeframeVector.Frame"> & {
  /**
   * TODO(dmaretskyi): Compress using numeric feed indexes.
   * TODO(burdon): Determine if admit DAG can be ordered. Requires space messages to be ordered (by lexical feed key).
   *
   * @generated from field: bytes feed_key = 1;
   */
  feedKey: Uint8Array;

  /**
   * @generated from field: int32 seq = 3;
   */
  seq: number;
};

/**
 * Describes the message dxos.echo.timeframe.TimeframeVector.Frame.
 * Use `create(TimeframeVector_FrameSchema)` to create a new message.
 */
export const TimeframeVector_FrameSchema: GenMessage<TimeframeVector_Frame> = /*@__PURE__*/
  messageDesc(file_dxos_echo_timeframe, 0, 0);

